import { apiClient } from './index.js';

async function getPrivacyPolicy({ type }) {
  const { data } = await apiClient({
    method: 'get',
    url: '/api/PrivacyPolicy/GetPolicy',
    params: {
      Type: type,
    },
    isAuthCheckSkipped: true,
  });
  return data;
}

export { getPrivacyPolicy };
